import { SessionContextProvider } from "@supabase/auth-helpers-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { TamaguiProvider } from "tamagui";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import tamaguiConfig from "./tamagui.config";
import { supabaseClient } from "./utils/supabase";

function setAppHeight() {
  document.documentElement.style.setProperty(
    "--app-height",
    `${window.innerHeight}px`
  );
}

window.addEventListener("resize", setAppHeight);
setAppHeight();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabaseClient}>
      <TamaguiProvider config={tamaguiConfig}>
        <App />
      </TamaguiProvider>
    </SessionContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
